import { PosterAdditionalInfoSection } from '../../PosterAdditionalInfoSection';
import { POSTER_DEMO_DATA } from '../posterDemoData';

interface MatchInfoScreenProps {
  onBack: () => void;
}

const { event, ticket, matchInfoHeader } = POSTER_DEMO_DATA;

const ROWS: { label: string; value: string }[] = [
  { label: 'Gate', value: ticket.gate },
  { label: 'Game', value: event.game },
  { label: 'Event', value: event.eventLabel },
  { label: 'Kick off', value: event.kickOffDisplay },
  { label: 'Date', value: event.date },
  { label: 'Seat', value: ticket.seat },
  { label: 'Ticket Holder', value: ticket.ticketHolder },
  { label: 'Ticket type', value: ticket.ticketType },
];

export const MatchInfoScreen = ({ onBack }: MatchInfoScreenProps) => (
  <PosterAdditionalInfoSection
    title={matchInfoHeader}
    rows={ROWS}
    onBack={onBack}
  />
);
